var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.969,
    height: 25.969,
    viewBox: "0 0 25.969 25.969",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#34366d;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 23.463,
    height: 23.463,
    rx: 2,
    transform: "translate(2 2)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2.095,
    cy: 2.095,
    r: 2.095,
    transform: "translate(7.028 7.028)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26.247,16.64,19.607,10,5,24.607",
    transform: "translate(-0.692 0.947)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPic);
export default __webpack_public_path__ + "static/media/pic.80fc0207cfcffd2c1156419655f37510.svg";
export { ForwardRef as ReactComponent };